import { defineMessages } from "react-intl"

export default defineMessages({
  socialHabitsCoop: {
    id: "app.components.SocialHabits.socialHabitsCoop",
  },
  socialHabitsPvP: {
    id: "app.components.SocialHabits.socialHabitsPvP",
  },
  "socialHabits.WithFriends": {
    id: "app.components.SocialHabits.socialHabits.WithFriends",
  },
  "socialHabits.WithStrangers": {
    id: "app.components.SocialHabits.socialHabits.WithStrangers",
  },
})
